<template>
  <div class="settings-card">
    <div class="card-header">
      <h3><i class="fas fa-user-friends"></i> Cấu hình Khách hàng</h3>
    </div>
    <div class="card-body">
      <div class="settings-list">
        <div class="setting-item">
          <div class="setting-info">
            <label>Tự động tạo khách hàng từ đơn hàng</label>
            <p>Nếu nhập SĐT lạ khi tạo đơn, hệ thống sẽ tự lưu thành khách hàng mới</p>
          </div>
          <van-switch v-model="localData.autoCreateCustomerFromOrder" @input="update" size="24px" />
        </div>

        <div class="setting-item">
          <div class="setting-info">
            <label>Bắt buộc có SĐT khi tạo đơn</label>
            <p>Ngăn chặn tạo đơn hàng nếu không nhập số điện thoại khách hàng</p>
          </div>
          <van-switch v-model="localData.requirePhoneOnOrder" @input="update" size="24px" />
        </div>

        <div class="form-group mb-4">
          <label>Nhóm khách hàng mặc định</label>
          <select v-model="localData.defaultCustomerType" @change="update" class="form-control">
            <option v-for="type in localData.customerTypes" :key="type" :value="type">
              {{ type.toUpperCase() }}
            </option>
          </select>
        </div>

        <div class="debt-limits">
          <label class="d-block mb-3 font-weight-bold">Hạn mức nợ theo nhóm</label>
          <div v-for="type in localData.customerTypes" :key="type" class="debt-limit-item">
            <span class="type-label">{{ type.toUpperCase() }}</span>
            <input 
              type="number" 
              v-model.number="localData.debtLimitByType[type]" 
              @change="update" 
              class="form-control-sm"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {
      localData: JSON.parse(JSON.stringify(this.data))
    }
  },
  watch: {
    data: {
      handler(val) {
        this.localData = JSON.parse(JSON.stringify(val));
      },
      deep: true
    }
  },
  methods: {
    update() {
      this.$emit('update', 'customer', this.localData);
    }
  }
}
</script>

